import { render, staticRenderFns } from "./dashboard-taskcount.vue?vue&type=template&id=47ac15bb&"
import script from "./dashboard-taskcount.vue?vue&type=script&lang=js&"
export * from "./dashboard-taskcount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports